<!-- <gig-project-header></gig-project-header> -->
<div class="" *ngIf="isTrafficDataAvailable; else noGoogleTrafficSourceData">
    <div class="date-picker-container flex flex-column gap-2">
        <label for="dateRange" class="text-sm font-semibold text-500">Select Date Range</label>
        <p-calendar [(ngModel)]="dateRange" selectionMode="range" (onSelect)="onDateRangeChange($event)"></p-calendar>
    </div>
    <div class="flex flex-wrap w-full gap-2">
        <div class="w-24rem">
            <gig-overview-box title="Visits" [overviewText]="generalKpiResponse.visits | number: '1.0-2'" [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box title="Avg. Session Duration (seconds)" [overviewText]="generalKpiResponse.avgSessionDuration | number: '1.0-2'" [showBadge]="false" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box title="Page Views per Session" [overviewText]="generalKpiResponse.pagesPerVisit | number: '1.0-2'" [showBadge]="false" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box title="Bounce Rate" [overviewText]="generalKpiResponse.bounceRate | number: '1.0-2'" [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" [isPercentage]="true" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box title="Page Views" [overviewText]="generalKpiResponse.pageViews | number: '1.0-2'" [showBadge]="false" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box title="Key Events" [overviewText]="generalKpiResponse.keyEvents | number: '1.0-2'" [showBadge]="false" type="number" toolTipPath="dashboard authority"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box [title]="'Total Active Users'" [overviewText]="gaSummaryDataActiveUser | number: '1.0-2'" [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" type="number" toolTipPath="dashboard.totalActiveUsers"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box [title]="'Total Sessions'" [overviewText]="gaSummaryDataSessions | number: '1.0-2'" [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" type="number" toolTipPath="dashboard.totalSessions"></gig-overview-box>
        </div>
        <div class="w-24rem">
            <gig-overview-box [title]="'Total New Users'" [overviewText]="gaSummaryDataNewUser | number: '1.0-2'" [showBadge]="false" [badgeClass]="'pi pi-arrow-down'" type="number" toolTipPath="dashboard.totalNewUsers"></gig-overview-box>
        </div>
    </div>
    <div class="grid gap-2">
        <div class="col-12">
            <div class="flex flex-row gap-2">
                <div class="card w-full">
                    <gig-chart-wrapper [chartData]="trafficDoughnutChartData" cardTitle="Traffic Source">
                        <gig-position-distribution-chart
                            [chartData]="trafficDoughnutChartData"
                            [chartColors]="chartColorsDoughnut"
                            chartType="doughnut"
                            type="traffic_source">
                        </gig-position-distribution-chart>
                    </gig-chart-wrapper>
                </div>
                <!-- Bar Chart: Default -->
                <div class="card w-full">
                    <gig-chart-wrapper [chartData]="visitsByUserTypeChartData" cardTitle="Visitor By User Type">
                        <gig-position-distribution-chart
                            [chartData]="visitsByUserTypeChartData"
                            [chartColors]="chartColors1"
                            chartType="bar"
                            type="visit_by_user_type">
                        </gig-position-distribution-chart>
                    </gig-chart-wrapper>
                </div>
            </div>
             <div class="flex flex-row w-full gap-2">
                 <div class="card w-full">
                     <gig-chart-wrapper [chartData]="visitsByOverTimeChartData" cardTitle="Visits Over Time">
                         <gig-position-distribution-chart
                             [chartData]="visitsByOverTimeChartData"
                             [chartColors]="chartColors1"
                             chartType="line"
                             type="weekly_sessions"
                             height="15rem">
                         </gig-position-distribution-chart>
                     </gig-chart-wrapper>
                 </div>

                 <div class="card w-full">
                     <gig-chart-wrapper [chartData]="bounceRateOverTimeChartData" cardTitle="Bounce Rate Over Time">
                         <gig-position-distribution-chart
                             [chartData]="bounceRateOverTimeChartData"
                             [chartColors]="chartColors1"
                             chartType="line"
                             type="weekly_sessions"
                             height="15rem">
                         </gig-position-distribution-chart>
                     </gig-chart-wrapper>
                 </div>
             </div>


             <div class="flex flex-row w-full gap-2">
                 <!-- Top Relevant Pages 1 -->
                 <div class="card w-full">
                     <gig-chart-wrapper [chartData]="top3ChannelsByConversionChartData" cardTitle="Top 3 Channels by Key Events">
                         <gig-position-distribution-chart
                             [chartData]="top3ChannelsByConversionChartData"
                             [chartColors]="chartColors1"
                             chartType="bar"
                             type="top3_campaigns"
                             height="15rem">
                         </gig-position-distribution-chart>
                     </gig-chart-wrapper>
                 </div>

                 <!-- Top Relevant Pages 2 (use a different sample or filtered data if available) -->
                 <div class="card w-full">
                     <gig-chart-wrapper [chartData]="top3CampaignsByConversionChartData" cardTitle="Top 3 Campaigns by Key Events">
                         <gig-position-distribution-chart
                             [chartData]="top3CampaignsByConversionChartData"
                             [chartColors]="chartColors1"
                             chartType="bar"
                             type="top3_campaigns"
                             height="15rem">
                         </gig-position-distribution-chart>
                     </gig-chart-wrapper>
                 </div>

                 <!-- Top Relevant Pages 3 (use a different sample or filtered data if available) -->
                 <div class="card w-full">
                     <gig-chart-wrapper [chartData]="top3PagesChartData" cardTitle="Top 3 Pages by Key Events">
                         <gig-position-distribution-chart
                             [chartData]="top3PagesChartData"
                             [chartColors]="chartColors1"
                             chartType="bar"
                             type="top3_campaigns"
                             height="15rem">
                         </gig-position-distribution-chart>
                     </gig-chart-wrapper>
                 </div>
             </div>

            <div class="card">
                <p-table [value]="referralSources" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items justify-content-between">
                            <div class="font-bold text-center">
                                <p class="text-lg text-500">
                                    Traffic Summary By Referral Source
                                </p>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    pButton
                                    pRipple
                                    icon="pi pi-file-excel"
                                    class="mr-2 p-button-text p-button-secondary p-button-lg p-button-rounded p-button-icon-only"
                                    tooltipPosition="bottom"
                                    (click)="onExportToExcel()">
                                </button>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Referral Source</th>
                            <th pSortableColumn="visits">Visits</th>
                            <th pSortableColumn="visitsPercentage">Share of Referral Sessions %</th>
                            <th pSortableColumn="newVisits">New Visits</th>
                            <th pSortableColumn="pageviewsPerVisit">Pageviews per Visit</th>
                            <th pSortableColumn="bounceRate">Bounce Rate</th>
                            <th pSortableColumn="rank">Rank</th>
                            <th pSortableColumn="backlinks">Backlinks</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-source>
                        <tr>
                            <td>{{ source.referralSource }}</td>
                            <td>{{ source.visits }}</td>
                            <td>{{ source.visitsPercentage }}</td>
                            <td>{{ source.newVisits }}</td>
                            <td>{{ source.pageviewsPerVisit }}</td>
                            <td>{{ source.bounceRate }}</td>
                            <td>{{ source.rank ?? 'No Rank Data' }}</td>
                            <td>{{ source.backlinks ?? 'No Backlink Data' }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Add Traffic by Country Table -->
            <div class="card">
                <p-table [value]="gaSummaryTableData" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="caption">
                        <div class="flex align-items justify-content-between">
                            <div class="font-bold text-center">
                                <p class="text-lg text-500">
                                    Traffic Summary By Country
                                </p>
                            </div>
                            <div>
                                <!-- <button
                                    type="button"
                                    pButton
                                    pRipple
                                    icon="pi pi-file-excel"
                                    class="mr-2 p-button-text p-button-secondary p-button-lg p-button-rounded p-button-icon-only"
                                    tooltipPosition="bottom">
                                </button> -->
                            </div>
                        </div>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Country</th>
                            <th>City</th>
                            <th pSortableColumn="sessions">Sessions</th>
                            <th pSortableColumn="activeUsers">Active Users</th>
                            <th pSortableColumn="newUsers">New Users</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.country }}</td>
                            <td>{{ row.city }}</td>
                            <td>{{ row.sessions }}</td>
                            <td>{{ row.activeUsers }}</td>
                            <td>{{ row.newUsers }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>
<ng-template #noGoogleTrafficSourceData>
    <div *ngIf="!hasLoaded" class="card">Loading Google Analytics data…</div>
    <div *ngIf="hasLoaded" class="card">
        <div class="card-body flex flex-column align-items-center justify-content-center p-5">
            <span class="pi text-5xl text-gray-400 mb-3" [ngClass]="authorizationRequired ? 'pi-lock' : 'pi-exclamation-circle'"></span>
            <h3 class="text-gray-600 mb-2">
                {{ authorizationRequired ? 'Google authorization expired.' : (loadError ? 'Google Analytics data could not be loaded.' : 'No traffic data available.') }}
            </h3>
            <p *ngIf="!authorizationRequired" class="text-gray-500 text-center">
                Please ensure that the Google integration is properly connected in the project settings.
            </p>
            <p *ngIf="authorizationRequired" class="text-gray-500 text-center">
                Your Analytics property is still configured. Reconnect Google to resume importing data.
            </p>
            <a *ngIf="authorizationRequired" class="p-button p-button-sm mt-2" routerLink="/settings/manage/projects">Reconnect Google</a>
        </div>
    </div>
</ng-template>
